/**
 * The bits both spreadsheet readers need: turning Excel's numeric dates into
 * the `YYYY-MM-DD` calendar strings the rest of OKANE speaks.
 */
const pad = (n) => String(n).padStart(2, '0')

/** Built-in number formats that mean "this number is a date". */
export const DATE_FORMAT_IDS = new Set([
  14, 15, 16, 17, 18, 19, 20, 21, 22, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 45, 46, 47, 50, 51,
  52, 53, 54, 55, 56, 57, 58,
])

/**
 * True for a custom format that draws a date or a time. Quoted literals and
 * colour/condition sections are dropped first, so `"day"` or `[Red]` in a
 * money format cannot be mistaken for a date token.
 */
export function isDateFormat(format) {
  const stripped = String(format ?? '')
    .replace(/\\./g, '')
    .replace(/"[^"]*"/g, '')
    .replace(/\[[^\]]*\]/g, '')
  return /[ymdhs]/i.test(stripped) && !/^general$/i.test(stripped.trim())
}

/**
 * Excel serial -> `YYYY-MM-DD`, or null when it is not a plausible date.
 *
 * Serial 1 is 1900-01-01, except that Excel also believes in 1900-02-29, so
 * everything below 61 is off by a day. Mac workbooks count from 1904 instead.
 */
export function serialToISO(serial, date1904 = false) {
  if (!Number.isFinite(serial)) return null
  let days = Math.floor(serial)
  if (date1904) days += 1462
  else if (days < 61) days += 1
  if (days < 1 || days > 2958465) return null // 1900-01-01 … 9999-12-31
  const date = new Date((days - 25569) * 86400000)
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`
}
